import React from 'react';
import styles from './ContextMenuSeparator.scss.js';

const ContextMenuSeparator = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  });
};
var ContextMenuSeparator$1 = ContextMenuSeparator;

export { ContextMenuSeparator$1 as default };
//# sourceMappingURL=ContextMenuSeparator.js.map
